export enum Directions {
  ltr = 'ltr',
  rtl = 'rtl',
}
